import { Text, View } from '@components/primitives';
import colors from '@theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Constants from 'expo-constants';

function ProfileAppVersion(): JSX.Element {
  const version = Constants.expoConfig?.version ?? Constants.manifest?.version;

  const { t } = useTranslation('common');

  return (
    <View flexDirection="row" justifyContent="center" marginTop="16px" marginBottom="8px">
      <Text testID="txtAppVersion" variant="xsm-bold" color={colors.neutral.darkMist}>
        {t('profile.appVersion')}:{version}{' '}
      </Text>
    </View>
  );
}

export default ProfileAppVersion;
